var path = '/home/jenkins/workspace/arcade_Arcade-UI_release/app/views/chrome/footer-container.html';
var html = "<arcade-shared-footer></arcade-shared-footer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;